import React from 'react';
import PropTypes from 'prop-types';

const AngleDivider = ({topColor, bottomColor, inverted=false}) => (
    <div className={inverted ? "angleDivider angleDivider--inverted" : "angleDivider"} style={{
        backgroundColor: `${topColor && topColor !== 'none' ? topColor : '#fff'}`,
        height: '10vw',
        maxHeight: '120px',
        position: 'relative',
        lineHeight: '0',
    }}>

        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             viewBox="0 0 1593 452.6" preserveAspectRatio="none" style={{
            enableBackground:'new 0 0 1593 452.6',
            width: '100vw',
            height: '102%',
            position: 'absolute',
            top: '0',
            right: '0',
            left: '0',
            bottom: '0',
        }} xmlSpace="preserve">
            <polygon style={{
                fill:`${bottomColor && bottomColor !== 'none' ? bottomColor : '#fff'}`,
                display: 'block'
            }} points={inverted ? "1593,452.6 1593,15.5 1593,10.5 1593,0 0,0 0,10.5 0,15.5" : "0,0 0,437.1 0,442.1 0,452.6 1593,452.6 1593,442.1 1593,437.1"}/>
        </svg>

    </div>
);

AngleDivider.propTypes = {
    topColor: PropTypes.string,
    bottomColor: PropTypes.string,
    inverted: PropTypes.bool
};

AngleDivider.defaultProps = {
    topColor: '#fff',
    bottomColor: '#fff',
    inverted: false
};

export default AngleDivider;



// WEBPACK FOOTER //
// ./frontend/components/AngleDivider/AngleDivider.jsx